import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 29,
	height: 5,
	fill: "none",
	viewBox: "0 5 29 10",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#EC4949",
		d: "M0 9.5V0h29v9.5L15 6 0 9.5Z"
	})
});
const SvgRibbonSmallBottom = styled(base)({});
export default SvgRibbonSmallBottom;
